import { t } from '@lingui/macro';

import { ProductLicence } from '@api';

/**
 * There are two scenarios for showing licence lock screen.
 * Either via product selector or the initial loading of the app.
 *
 * @see https://bitbucket.org/mathletics/3p-portal/src/c0f90eb0c2e629c170e29e3bbd482fc3db0cd3ea/common/localized-messages/localizedMessages.js#localizedMessages.js-2
 * @see https://bitbucket.org/mathletics/3p-portal/src/cb2b7c4a900da9ee5ca0ef946956c6e99c8cbfef/common/directive/product-selector/product-selector.js#product-selector.js-90
 */
export function licenceErrorMessage (
    isDefaultProduct: boolean,
    product: ProductLicence | null,
    products: Array<ProductLicence>
) {
    if (isDefaultProduct) {
        return t`licence.error.title`;
    }

    const values = {
        product: product?.title || 'mathletics',
        supportLink: product?.productUrl || null
    };

    let message = t({
        id: 'licence.error',
        values
    });

    if (products.length > 1) {
        message = message + t`licence.otherproduct`;
    }

    return message;
}
